export default {"src":"/_next/static/media/underlineHome.3fe9f392.svg","height":13,"width":279,"blurWidth":0,"blurHeight":0};